// Copyright (c) 2017, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React, { Fragment } from 'react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

import {
  NavLink,
  Warning
} from '../'

import {
  encodeBase64,
  getNodeUrl,
  getNodeTypeFromContentTypeModel
} from '../../utils'

import { NODES } from '../../constants'


export class RelatedObject extends React.PureComponent {
  state = {
    nodeUrl: undefined
  }

  render() {
    const { objectUuid, contentTypeModel } = this.props

    if (contentTypeModel === 'email' || contentTypeModel === 'message') {
      // we're ignoring related email & message (sms) objects for two reasons:
      // 1. inbound messages already show up in case activity so we don't need to duplicate in case sidebar
      // 2. we don't have a message detail pages to link to
      return null
    }

    let nodeType = getNodeTypeFromContentTypeModel(contentTypeModel)
    let objectId = encodeBase64(objectUuid, nodeType)

    if (this.state.nodeUrl === undefined) {
      this.setState(
        { nodeUrl: null },
        () => (
          getNodeUrl(objectId, true)
          .then(nodeUrl => this.setState({ nodeUrl }))
          .catch(() => this.setState({ nodeUrl: 'error' }))
        )
      )
    }

    if (this.state.nodeUrl === null) {
      return null
    }

    if (this.state.nodeUrl === 'error') {
      return (
        <Fragment>
          <Warning iconSize='x-small'>
            Error fetching item's URL
          </Warning>
        </Fragment>
      )
    }
    return (
      <Query query={gql`${NODES[nodeType].query}`} variables={{ id: objectId }}>
        {({ loading, error, data }) => {
          if (loading) {
            return null
          }

          if (error) {
            return (
              <Warning iconSize='x-small'>
                Error fetching item
              </Warning>
            )
          }

          return (
            <NavLink to={!!this.state.nodeUrl && this.state.nodeUrl}>
              {data.object.summary}
            </NavLink>
          )
        }}
      </Query>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/case-sidebar/RelatedObject.js